import { DTOTam } from './dtoTam';
export class DTOAcompanharPedido{ 
    NumPedido : string;
    PrimeiraCartela : string;
    SegundaCartela : string;
    NomeEmpresaVendedor: string;
    CodRepresentante: number;
    NomeRepresentante: string;        
    Status: string;
    ImgFrente: string;
    ImgVerso: string;
    DTOTam: DTOTam[];
    ObsLog: string;
    VeInfoPedido: boolean=false;

    deserialize(input: Object): DTOAcompanharPedido {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/dto/dtoAcompanharPedido.ts